// Import model
import { StartObjectAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartObjectAppointmentSendUpcomingAppointmentReminderRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentSendUpcomingAppointmentReminderRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentSendUpcomingAppointmentReminderRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentSendUpcomingAppointmentReminderRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentSendUpcomingAppointmentReminderRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentSendUpcomingAppointmentReminderRequest');
    }


    const instance: StartObjectAppointmentSendUpcomingAppointmentReminderRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentSendUpcomingAppointmentReminderRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentSendUpcomingAppointmentReminderRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentSendUpcomingAppointmentReminderRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentSendUpcomingAppointmentReminderRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentSendUpcomingAppointmentReminderRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentSendUpcomingAppointmentReminderRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentSendUpcomingAppointmentReminderRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentSendUpcomingAppointmentReminderRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
